import React from 'react';
import {getRandomArrayElement} from '../../../library';
import {COPY_STRINGS} from '../../../constants/translatedCopy';
import {getUserData} from '../../../services/API';
import story_badge from "../../../images/EndofAssessmentComp-img-02.svg";
import { getCopyByGradeband } from '../../../services/ThemingService';
import backIconSimple from '../../../images/icons/iconBack_simple.svg';
import readAStorySimple from '../../../images/icons/iconReadStory_simple.svg';
import classNames from 'classnames';
import { logSentryException } from '../../../services/util';
import Loading from '../../Global/Loading';

export class EarlyReaderStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayNavButtons: false,
      buttonsDisabled: false,
    };
    this.speechTimeoutId = null;
    this.navigationInProgress = false;
    this._actionLocked = false;
    this.goHome = this.goHome.bind(this);
    this.moveToInbox = this.moveToInbox.bind(this);
    this.openStoryPicker = this.openStoryPicker.bind(this);
    this.handleButtonHover = this.handleButtonHover.bind(this);
  }

  componentDidMount(){
    const textToSpeak = `${getRandomArrayElement(getCopyByGradeband(COPY_STRINGS, 'onFire'))} <break time=\"0.25s\"/> ${getCopyByGradeband(COPY_STRINGS, 'finished_story')}`;
    
    // Enhanced speech completion handler with error handling
    const handleSpeechComplete = (error = null) => {
      if (this.speechTimeoutId) {
        clearTimeout(this.speechTimeoutId);
        this.speechTimeoutId = null;
      }
      
      if (error) {
        console.error('EarlyReaderStatus speech error:', error);
        logSentryException(new Error('EarlyReaderStatus speech playback failure'), 'EarlyReaderStatus speech failed', { originalError: error?.message, originalStack: error?.stack });
      }
      
      if (!this.navigationInProgress) {
        this.goHome();
      }
    };

    // Add timeout safeguard to ensure goHome is called
    this.speechTimeoutId = setTimeout(() => {
      console.warn('EarlyReaderStatus: Speech timed out after 20 seconds, proceeding to goHome');
      logSentryException(new Error('EarlyReaderStatus speech timeout'), 'EarlyReaderStatus speech timeout', {
        textToSpeak: textToSpeak
      });
      handleSpeechComplete();
    }, 20000);

    let speechProps = {
      textToSpeak: textToSpeak,
      onEnd: () => handleSpeechComplete(),
      onError: (error) => handleSpeechComplete(error),
    };
    
    try {
      this.props.speech.speak(speechProps);
    } catch (error) {
      console.error('EarlyReaderStatus: Failed to start speech:', error);
      logSentryException(new Error('EarlyReaderStatus speech initialization failure'), 'EarlyReaderStatus speech initialization failed', { originalError: error?.message, originalStack: error?.stack });
      // Immediate fallback if speech fails to start
      setTimeout(() => handleSpeechComplete(error), 5000);
    }
  }

  componentWillUnmount(){
    if (this.speechTimeoutId) {
      clearTimeout(this.speechTimeoutId);
      this.speechTimeoutId = null;
    }
    if (this._recoveryTimeoutId) {
      clearTimeout(this._recoveryTimeoutId);
      this._recoveryTimeoutId = null;
    }
  }

  canDisplayNavButtons(){
    const userData = getUserData();
    const { tutor, instruct } = userData.subscriptions || {};
    return window.location.pathname === '/student/tutor' && tutor && !this.props.hasStudentAssignment;
  }

  goHome(){
    // Prevent duplicate calls
    if (this.navigationInProgress) {
      console.log('EarlyReaderStatus: goHome already in progress, skipping duplicate call');
      return;
    }

    this.navigationInProgress = true;

    // Clear any pending speech timeout
    if (this.speechTimeoutId) {
      clearTimeout(this.speechTimeoutId);
      this.speechTimeoutId = null;
    }

    // If this.props.returnUrl exists, then navigate to that URL
    if (this.props.returnUrl) {
      // If student is a tutor subscriber and not an instruct subscriber, we give option to read another story / go back to inbox.
      if (this.canDisplayNavButtons()) {
        this.setState({ displayNavButtons: true });
        return;
      }
      window.location.href = this.props.returnUrl;
      return;
    }

    this.props.history.push('/student/home');
  }

  moveToInbox() {
    if (this._actionLocked) return;
    this._actionLocked = true;
    this.setState({ buttonsDisabled: true });
    this.props.speech.abortSpeech();
    this._startRecoveryTimeout();
    window.location.href = this.props.returnUrl;
  }

  openStoryPicker() {
    if (this._actionLocked) return;
    this._actionLocked = true;
    this.setState({ buttonsDisabled: true });
    this.props.speech.abortSpeech();
    this._startRecoveryTimeout();
    this.props.resetStory();
  }

  handleButtonHover(textToSpeak) {
    if (this._actionLocked) return;
    this.props.speech.abortSpeech(() => {
      this.props.speech.speak({
        textToSpeak: textToSpeak
      });
    });
  }

  /**
   * Safety net: if the component is still mounted and locked after 15s
   * (e.g. fetch hang or abortSpeech callback drop), restore buttons so
   * the student can retry or navigate away.
   */
  _startRecoveryTimeout() {
    clearTimeout(this._recoveryTimeoutId);
    this._recoveryTimeoutId = setTimeout(() => {
      if (this._actionLocked) {
        this._actionLocked = false;
        this.setState({ buttonsDisabled: false });
      }
    }, 15000);
  }

  render() {
    let btnOptions = (
      <div className="optionsWrapper">
        <button 
          className="optionButton"
          onClick={this.moveToInbox}
          onMouseEnter={() => this.handleButtonHover(COPY_STRINGS.finished)}
        >
          <img src={backIconSimple} alt="back_icon"/>
          <span className="optionTitle">{COPY_STRINGS.finished}</span>
        </button>
        <>
          <button 
            className="optionButton readMoreBtn"
            onClick={this.openStoryPicker}
            onMouseEnter={() => this.handleButtonHover(COPY_STRINGS.read_more)}
          >
            <img src={readAStorySimple} alt="read_more_icon"/>
            <span className="optionTitle">{COPY_STRINGS.read_more}</span>
          </button>
        </>
      </div>
    )

    return (
      <div className={classNames("endOfStoryModal", {
        "noMaxWidth": this.canDisplayNavButtons()
      })}>
        <div className="praise">{COPY_STRINGS.great_work}</div>
        <div className="badgeContainer">
          <img className="badge" src={story_badge} alt="" />
        </div>
        {this.state.displayNavButtons ? (
          this.state.buttonsDisabled
            ? <div className="endOfStoryLoading"><Loading noFill={true}/></div>
            : btnOptions
        ) : null}
      </div>
    );
  }
}
